import {AvailabilitiesResponse, PricesResponse, WiypResponse} from "@/types/responses"

export interface IResponsesCache {
    setResponse(responseType: "availabilities" | "prices", cacheKey: string, response: AvailabilitiesResponse | PricesResponse | WiypResponse): void
    getResponse(responseType: "availabilities" | "prices", cacheKey: string): AvailabilitiesResponse | PricesResponse | WiypResponse | null
    getAllResponsesOfType(responseType: "availabilities" | "prices"): Record<string, AvailabilitiesResponse | PricesResponse | WiypResponse> | null
    // reinit(): void // NOT IN USE ANYMORE
}

class ResponsesCache implements IResponsesCache {
    private availabilities: Map<string, AvailabilitiesResponse> = new Map()
    private prices: Map<string, PricesResponse> = new Map()

    setResponse(responseType: "availabilities" | "prices", cacheKey: string, response: AvailabilitiesResponse | PricesResponse ): void {
        switch(responseType) {
            case "availabilities":
                this.availabilities.set(cacheKey, response as AvailabilitiesResponse)
                break
            case "prices":
                this.prices.set(cacheKey, response as PricesResponse)
                break
            default:
                throw new Error(`type "${responseType}" is not recognized`)
        }
    }

    getResponse(responseType: "availabilities" | "prices", cacheKey: string): AvailabilitiesResponse | PricesResponse | null {
        switch(responseType) {
            case "availabilities":
                return this.availabilities.get(cacheKey) || null
            case "prices":
                return this.prices.get(cacheKey) || null
            default:
                throw new Error(`type "${responseType}" is not recognized`)
        }
    }

    getAllResponsesOfType(responseType: "availabilities" | "prices"): Record<string, AvailabilitiesResponse | PricesResponse | WiypResponse> | null {
        switch(responseType) {
            case "availabilities":
                return Object.fromEntries(this.availabilities)
            case "prices":
                return Object.fromEntries(this.prices)
            default:
                throw new Error(`type "${responseType}" is not recognized`)
        }
    }

    // reinit(): void // NOT IN USE ANYMORE
    //     this.availabilities.clear()
    //     this.prices.clear()
    // }
}

export default ResponsesCache